import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import getSxAttributes from 'helpers/getSxAttributes';

const InlineList = (props) => {
  const { children, className, sx } = props;

  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: props.align,
        ...getSxAttributes(theme, sx),
      })}
      className={className}
    >
      {children.map((child, index) => (
        <Box
          key={String(index)}
          sx={{
            margin: props.align === 'left' ? '0 8px 8px 0' : '0 4px 8px 4px',
            minWidth: 'unset',
          }}
        >
          {React.cloneElement(child)}
        </Box>
      ))}
    </Box>
  );
};

export const alignTypes = ['left', 'center'];

InlineList.propTypes = {
  align: PropTypes.oneOf(alignTypes),
  children: PropTypes.node,
  className: PropTypes.string,
};

InlineList.defaultProps = {
  children: false,
  align: 'left',
  className: null,
};

export default InlineList;
